// extracted by mini-css-extract-plugin
export var closeButton = "imageCard-module--closeButton--3ec72";
export var greenBorder = "imageCard-module--greenBorder--6c637";
export var icon = "imageCard-module--icon--08c80";
export var imageCard = "imageCard-module--imageCard--c248b";